import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { LoggedUser } from '@/api/auth/types/LoggedUser'
import { QUERY_KEYS } from '@/lib/queryKeys'

import { completeOnboarding } from '../userService'

export const useCompleteOnboarding = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => completeOnboarding(),
    onSuccess: data => {
      queryClient.setQueryData<LoggedUser>([QUERY_KEYS.LOGGED_USER], prev =>
        prev
          ? {
              ...prev,
              onboardingCompletedAt: data.onboardingCompletedAt ?? new Date().toISOString(),
            }
          : prev
      )
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.LOGGED_USER] })
    },
  })
}
